<template>
  <v-container>
    <div
      v-if="!checkIfPermission('view transfer', admin.permissions)"
      class="w-100 h-100 d-flex justify-center align-center"
    >
      <h1 class="error--text">You don't have access to this page</h1>
    </div>
    <div v-else>
      <h1 class="mb-5">SnappyGift</h1>
      <user-details-min :userId="minUserId" :open.sync="openMin" />
      <v-row>
        <v-col>
          <v-card flat color="white">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search..."
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="arrangedTransaction"
              :items-per-page="perPage"
              :loading="loadingTransaction"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 15, 25, 50, 100]
              }"
              @update:items-per-page="updateItemPerPage"
              @update:page="updatePage"
              :server-items-length="apiData.total"
            >
              <template v-slot:[`item.user`]="{ item }">
                <!-- <router-link
                  :to="{ name: 'ViewUser', params: { id: item.user_id } }"
                  class="font-weight-medium text-capitalize d-block"
                  >{{ item.user }}</router-link
                > -->
                <span
                  class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                  @click="openMinDialog(item.user_id)"
                >
                  {{ item.user }}
                </span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-card
                  :color="
                    item.status == 'approved'
                      ? 'success'
                      : item.status == 'pending'
                      ? 'warning'
                      : 'error'
                  "
                  flat
                  rounded="md"
                  outlined
                  class="text-capitalize text-center white--text pa-1"
                >
                  {{ item.status }}
                </v-card>
              </template>
              <template v-slot:[`item.currency`]="{ item }">
                <span class="font-weight-medium">{{ item.currency }}</span>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <small class="font-weight-medium">{{ item.date }}</small>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <span>
                  <span class="grey--text text--darken-2">{{
                    item.currency
                  }}</span>
                  {{ item.amount }}</span
                >
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn small depressed @click.stop="selectTransaction(item)"
                  >View Details</v-btn
                >
              </template>
            </v-data-table>
            <!-- <delete-dialog :open.sync="dialogDelete" type="sales" /> -->
            <fund-details
              :actionProgress.sync="progress"
              :open.sync="transactionOpen"
              :transaction="transaction"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import fundDetails from '../../../components/fundDetails.vue'
import transferApi from '../../../api/admin/transfer'
import { numberWithCommas } from '../../../utils/helpers'
import { mapState } from 'vuex'
import UserDetailsMin from '../../../components/userDetailsMin.vue'
import _ from 'lodash'

export default {
  components: {
    fundDetails,
    UserDetailsMin
  },
  data: () => ({
    openMin: false,
    minUserId: '',
    progress: 'starting',
    search: '',
    transactionOpen: false,
    dialogDelete: false,
    headers: [
      {
        text: 'Date',
        align: 'start',
        value: 'date'
      },
      {
        text: 'User',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'TRX ID',
        value: 'transaction_id'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: '',
        value: 'action',
        sortable: false
      }
    ],
    transactions: [],
    transaction: {},
    perPage: 10,
    loadingTransaction: false,
    apiData: {},
    lastPage: 1
  }),
  created() {
    this.getTransactions(0)
    this.debounceSearch = _.debounce(this.searchData, 500)
  },
  watch: {
    progress(newValue, oldValue) {
      if (newValue === 'done') {
        this.getTransactions()
      }
      this.progress = 'starting'
    },
    search(newValue) {
      if (newValue === '') {
        this.getTransactions(0)
        return
      }
      this.debounceSearch()
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admin.admin
    }),
    arrangedTransaction() {
      if (this.transactions.length !== []) {
        return this.transactions.map((transaction) => ({
          ...transaction,
          id: transaction._id,
          date: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toDateString(),
          time: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toUTCString(),
          user: transaction.user?.username,
          user_id: transaction.user?._id,
          status: transaction.status,
          transaction_id: transaction.transaction_id,
          amount: numberWithCommas(transaction.amount)
        }))
      }
      return []
    }
  },
  methods: {
    openMinDialog(id) {
      this.openMin = true
      this.minUserId = id
    },
    async searchData() {
      this.loadingTransaction = true
      this.transactionsM = []
      const res = await transferApi.data().getTransfers({
        populate: ['user', 'actionby'],
        limit: this.perPage,
        keyword: this.search,
        source: 'admin'
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    updatePage(page) {
      if (this.lastPage - page > 2) {
        page = this.lastPage
      }
      this.lastPage = page
      this.getTransactions((page - 1) * this.perPage)
    },
    updateItemPerPage(count) {
      this.perPage = count
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    async getTransactions(length) {
      this.loadingTransaction = true
      const res = await transferApi.data().getTransfers({
        populate: ['user'],
        limit: this.perPage,
        offset: length,
        source: 'user'
      })

      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    selectTransaction(transx) {
      const transaction = this.transactions.find((trx) => trx._id === transx.id)

      this.transaction = {
        ...transaction,
        user: transaction.user,
        date: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toDateString(),
        time: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toTimeString(),
        status: transaction.status,
        transactionInfo: [
          {
            title: 'Transaction Type',
            text: `Transfer`
          },
          {
            title: `Reason for Decline`,
            text: `${
              transaction.remarks ? transaction.remarks : 'No reason given'
            }`
          },
          {
            title: 'Receiver',
            text: transaction.send_details
          },
          {
            title: 'Amount',
            text: `${numberWithCommas(transaction.amount)} ${
              transaction.currency
            }`
          },
          {
            title: 'TRX ID',
            text: transaction.transaction_id
          },
          {
            title: 'Actioned At',
            text: new Date(
              transaction.actioned_at
                ? transaction.actioned_at
                : transaction.actionedAt
            ).toUTCString()
          }
        ]
      }
      this.transactionOpen = true
    }
  }
}
</script>

<style></style>
